import { Box, Button, Dialog, DialogContent, Typography } from "@mui/material";
import { darkGreenColor, grayColor, redColor, whiteColor } from "../../../constants/constants";
import { closeRemoveDialog } from "../../../core/state/dialogs/removeRecordDialogSlice";
import { useAppDispatch, useAppSelector } from "../../../core/state/hooks";
import { removeRecord } from "../../../core/state/dailyTracker/dailyTrackerSlice";
import { useEffect } from "react";

export default function RemoveRecordDialog() {
    const dispatch = useAppDispatch();
    const {isOpen: dialogIsOpen, recordToDelete} = useAppSelector((state) => state.removeRecordDialog);

    const handleCancel = () => {
        dispatch(closeRemoveDialog());
    };

    const handleDelete = () => {
        dispatch(removeRecord(recordToDelete));
        dispatch(closeRemoveDialog());
    };

    useEffect(() => {
        if (!dialogIsOpen) return;

        const handleKeyDown = (event: KeyboardEvent) => {
            if (event.key === 'Escape') {
                handleCancel();
            } else if (event.key === 'Enter' && !event.shiftKey && !event.ctrlKey && !event.metaKey) {
                event.preventDefault();
                handleDelete();
            }
        };

        window.addEventListener('keydown', handleKeyDown);
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [dialogIsOpen]);

    return (
        <Dialog 
            open={dialogIsOpen} 
            onClose={handleCancel}
            maxWidth="xs"
            disableEscapeKeyDown={false}
            slotProps={{
                backdrop: {
                    sx: { backgroundColor: 'transparent' }
                }
            }}
            PaperProps={{
                sx: {
                    boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.15)',
                    borderRadius: 2
                }
            }}
        >
            <DialogContent sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', p: 3 }}>
                <Typography variant='h6' sx={{ mb: 3 }}>¿Desea eliminar el registro?</Typography>
                <Box sx={{ display: 'flex', gap: 2 }}>
                    <Button 
                        sx={{
                            px: 3,
                            py: 1,
                            backgroundColor: grayColor, 
                            color: whiteColor,
                            '&:hover': { backgroundColor: darkGreenColor }
                        }}
                        onClick={handleCancel}
                    >
                        Cancelar
                    </Button>
                    <Button 
                        sx={{
                            px: 3,
                            py: 1,
                            backgroundColor: redColor, 
                            color: whiteColor,
                            '&:hover': { backgroundColor: darkGreenColor }
                        }}
                        onClick={handleDelete}
                    >
                        Eliminar
                    </Button>
                </Box>
            </DialogContent>
        </Dialog>
    );
}